import React from 'react';
import EllipseControl from '../../../EllipsesControl/EllipsesControl';
import RiskFactorsList from './RiskFactors/RiskFactorList';
import AccountList from '../Risks/Accounts/AccountList';
import styled from 'styled-components';

export default function RiskListItem(props) {
	const {risk, getBodiesBySectionId, isDisplayAccounts, isDisabled} = props;
	return (
		<>
			<StyledRiskListItem className="StyledRiskListItem">
				<span className="risk-name">
					<EllipseControl
						content={risk.riskName}
						tooltip={risk.riskName}
						noOfLines={1}
						tooltipClass="tooltipCustomWidth"
					/>
				</span>
				<RiskFactorsList riskFactorsList={risk.riskFactorRelations} isDisabled={isDisabled} />
				{isDisplayAccounts && (
					<AccountList
						assertions={risk.assertionsGroupedByRiskTypes}
						risk={risk}
						getBodiesBySectionId={getBodiesBySectionId}
						isDisabled={isDisabled}
					/>
				)}
			</StyledRiskListItem>
		</>
	);
}

const StyledRiskListItem = styled.li`
	padding: 0 var(--px-20);
	margin-bottom: var(--px-8);
	.risk-name {
		display: block;
		width: calc(100% - var(--px-40));
		font-size: var(--px-16);
		font-weight: 400;
		margin-bottom: var(--px-12);
		line-height: var(--px-24);
		color: var(--neutrals-900);
	}
	.addaccount-link {
		.motif-icon {
			svg {
				width: var(--px-20) !important;
				height: var(--px-20) !important;
			}
		}
		.add-account-label {
			line-height: var(--px-20);
		}
	}
`;
